import { Box, Container, Typography, Grid } from "@mui/material";
import React from "react";
import { icons, images } from "../../assets";
import { allColors } from "../../constants";
import { ExpandMore } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const BroadbandSection = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box
        bgcolor={allColors.brightGray}
        pt={5.63}
        pb={{ xs: 0, sm: 29 }}
        position={"relative"}
      >
        <Container
          sx={{
            maxWidth: "1250px !important",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontSize: { xs: "35px", md: "50px" },
              color: allColors.jetBlack,
              fontWeight: "600",
              fontFamily: "Raleway",
              lineHeight: { xs: "40px", sm: "50px" },
            }}
          >
            We value loyalty. And reward it.
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "25px",
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontSize: { xs: "17px", md: "21px" },
                color: allColors.jetBlack,
                fontWeight: "300",
                fontFamily: "Raleway",
                marginLeft: { xs: 0, sm: "10px" },
              }}
            >
              <img
                src={icons.circleCheckIcon}
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "10px",
                }}
              />
              Receive{" "}
              <Typography
                component={"span"}
                sx={{
                  fontWeight: "700",
                  textDecoration: "underline",
                  fontSize: { xs: "17px", sm: "28px" },
                }}
              >
                £70 cash
              </Typography>{" "}
              for every new customer you introduce, <br /> paid directly into
              your bank account.
            </Typography>
          </Box>
        </Container>
        <Grid
          container
          spacing={{ xs: 0, sm: 4 }}
          alignItems={"center"}
          sx={{ position: { xs: "relative", sm: "absolute" }, bottom: "-8px" }}
          flexDirection={{ xs: "column-reverse", sm: "row" }}
          // marginTop={{ xs: "100px", sm: "-200px", md: "-210px", xl: "-230px" }}
        >
          <Grid item xs={12} md={5}>
            <img
              src={images.broadbandElephantLeftImg}
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Box sx={{ textAlign: "center", marginTop: { xs: "35px", sm: 0 } }}>
              <a href="#contact-us" style={{ textDecoration: "none" }}>
                <Typography
                  sx={{
                    fontSize: { sx: "18px", sm: "20px" },
                    color: allColors.blueCrayola,
                    fontWeight: "500",
                  }}
                >
                  Refer A Friend – Contact Us
                </Typography>
              </a>
              <ExpandMore
                sx={{
                  width: "40px",
                  height: "30px",
                  color: allColors.blueCrayola,
                }}
              />
            </Box>
            <Typography
              sx={{
                textDecoration: "underline",
                textAlign: "center",
                cursor: "pointer",
                fontSize: "12px",
                marginTop: "20px",
                display: { xs: "none", sm: "block" },
              }}
              onClick={() => navigate("/terms-&-conditions")}
            >
              Terms apply
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            sx={{ display: { xs: "none", sm: "block" } }}
          >
            <img
              src={images.broadbandElephantRightImg}
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Typography
        sx={{
          textDecoration: "underline",
          textAlign: "center",
          cursor: "pointer",
          fontSize: "12px",
          marginTop: "20px",
          display: { xs: "block", sm: "none" },
        }}
        onClick={() => navigate("/terms-&-conditions")}
      >
        Terms apply
      </Typography>
    </>
  );
};

export default BroadbandSection;
